<template>

  <div class="content">

    <center v-if="!billing">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 40px; color: #1BD285;" spin />
      </a-spin>
    </center>

    <template v-else>

      <!-- Wallet Container -->
      <div class="wallet-container">

        <div class="wallet-inner-container">
          <p class="balance">${{ billing.wallet_balance.toFixed(2) }}</p>
          <p class="remaining">Remaining Balance</p>
          <p class="topup-prompt">Need More? <span @click="$refs.topup_modal.open();">Request a top up.</span></p>
          <!-- <p class="topup-prompt">Need More? <span>Request a top up.</span></p> -->
        </div>

      </div>

      <!-- Usage Container -->
      <div class="usage-container table-container">

        <h4>Usage</h4>

        <div class="monthly-usage-container" v-for="(row, row_index) of billing.monthly_usage">
          <h4>{{ `${getMonthFromInt(row.date.split('_')[1])} ${row.date.split('_')[0]}` }}</h4>
          <div @click="toggleAnswerDetails(row_index)" class="expand-answer-usage-details" :class="{ expanded: row.is_answer_details_shown }"></div>
          <div>
            <p>Answers</p>
            <p v-show="!row.is_answer_details_shown">{{ row.answers.count - row.say.count }}</p>
            <p v-show="!row.is_answer_details_shown">${{ row.answers.cost.toFixed(2) }}</p>
          </div>
          <div class="answer-usage-details" v-if="row.is_answer_details_shown">
            <div>
              <p>Video</p>
              <p>{{ row.video.count }}</p>
              <p>${{ row.video.cost.toFixed(2) }}</p>
            </div>
            <div>
              <p>Audio</p>
              <p>{{ row.audio.count }}</p>
              <p>${{ row.audio.cost.toFixed(2) }}</p>
            </div>
            <div>
              <p>Image</p>
              <p>{{ row.image.count }}</p>
              <p>${{ row.image.cost.toFixed(2) }}</p>
            </div>
            <div>
              <p>Text</p>
              <p>{{ row.text.count }}</p>
              <p>${{ row.text.cost.toFixed(2) }}</p>
            </div>
            <div>
              <p>Multi</p>
              <p>{{ row.multi_choice.count }}</p>
              <p>${{ row.multi_choice.cost.toFixed(2) }}</p>
            </div>
            <div>
              <p>Location</p>
              <p>{{ row.location.count }}</p>
              <p>${{ row.location.cost.toFixed(2) }}</p>
            </div>
            <div>
              <p>Content</p>
              <p>{{ row.say.count }}</p>
              <p>${{ row.say.cost.toFixed(2) }}</p>
            </div>
          </div>
          <div>
            <p>Pushes</p>
            <p>{{ row.pushes.count }}</p>
            <p>${{ row.pushes.cost.toFixed(2) }}</p>
          </div>
          <div>
            <p>Monthly Usage</p>
            <p><b>${{ (row.pushes.cost + row.answers.cost).toFixed(2) }}</b></p>
          </div>
        </div>

        <!-- By Survey Usage -->
        <h4>By Survey Usage</h4>
        <div class="survey-usage-container">
          <div v-for="(row, row_index) of billing.survey_usage">
            <p>{{ row.title }}</p>
            <p>${{ row.usage.toFixed(2) }}</p>
          </div>
        </div>

      </div>



      <!-- Top Up Container -->
      <div class="topup-container table-container">

        <h4>Top Ups</h4>

        <div class="table-headers">
          <div>
            <p>Date</p>
          </div>
          <div>
            <p>$ Credit</p>
          </div>
        </div>

        <div class="table-row" v-for="row of billing.top_ups">
          <div>
            <p>{{ `${getMonthFromInt(row.date.split('_')[1])} ${row.date.split('_')[2]}, ${row.date.split('_')[0]}` }}</p>
          </div>
          <div>
            <p>${{ row.amount.toFixed(2) }}</p>
          </div>
        </div>

        <div class="table-row">
          <div>
            <p><b>Total</b></p>
          </div>
          <div>
            <p><b>${{ _.sum(_.map(billing.top_ups, 'amount')).toFixed(2) }}</b></p>
          </div>
        </div>

      </div>


      <div class="billing-settings-container">
        <div class="hide-wallet-toggler">
          <p>Hide Wallet Balance and New Survey Pricing</p>
          <a-switch :checked="is_wallet_hidden" @change="toggleHideWallet" />
        </div>
      </div>

    </template>


    <!-- Request Top Up Modal -->
    <sweet-modal overlay-theme="dark" ref="topup_modal" class="topup-request-modal" width="500">

      <h3>💳</h3>
      <h4>Submit a top up request and your<br>account manager will get back to you</h4>
      <input type="number" placeholder="Enter a top up amount" v-model="topup_amount">
      <button @click="submitTopUpRequest()">Submit Request</button>

    </sweet-modal>

  </div>

</template>

<script>

import moment from 'moment';

export default {

  name: 'Billing',

  data: function () {
    return {
      topup_amount: "",
    }
  },

  computed: {
    billing() {
      return this.$store.state.billing;
    },
    is_wallet_hidden() {
      if (this.$store.state.user && this.$store.state.user.settings) {
        return this.$store.state.user.settings.is_wallet_hidden === true;
      } else {
        return false;
      };
    },
  },

  components: {},

  methods: {

    getMonthFromInt(month_int) {
      return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'][month_int-1];
    },

    submitTopUpRequest() {

      let topup_amount = this.topup_amount;
      let account_name = this.$store.state.account.name;
      let client_name = this.$store.state.user.name;
      let client_email = this.$store.state.user.email;

      this.$message.success(`Top up request sent`, 3); // Show message for 3 seconds
      this.$refs.topup_modal.close();

      this.$axios.post(`https://api-outsidevoice.vercel.app/send-topup-email`, {
        account_name,
        client_name,
        client_email,
        topup_amount
      }).then(res => {
        console.log('submitted request');
      }).catch(err => {
        console.log(err);
      });

    },

    toggleAnswerDetails(index=0) {
      this.$store.commit('toggleAnswerDetailsShown', index);
    },

    toggleHideWallet(checked) {
      var update = {};
      update[`settings.is_wallet_hidden`] = checked;
      this.$store.dispatch('updateUser', update);
    },

  },

  mounted() {

    let billing = this.$store.state.billing;

    if (!billing) { // User has not yet been inited - the page was loaded directly.
      this.$store.dispatch('setBilling');
    };

  },

  created() {
    analytics.page('Billing');
  }

}
</script>

<style scoped lang="scss">

.content{
  padding: 40px 4%;
}

.billing-container{
  justify-content: space-between;
  align-items: stretch;
  display: flex;
}

.wallet-container{
  margin: 0 auto;
  width: 330px;
  padding: 30px;
  margin-top: 20px;
  background-color: rgb(253,253,253);
  border: 1px solid rgb(230,230,230);
  border-radius: 8px;
  p{
    text-align: center;
  }

  .balance{
    color: rgb(30,30,30);
    font-size: 34px;
    font-weight: 500;
    margin-bottom: 10px;
  }

  .remaining{
    color: rgb(130,130,130);
    font-size: 15px;
  }

  .topup-prompt{
    font-size: 14px;
    span{
      color: #17D189;
      font-weight: 600;
      cursor: pointer;
    }
    margin-bottom: 5px;
  }

}


.table-container{
  display: block;
  margin: 0 auto;
  margin-top: 50px;
  h4{
    font-size: 17px;
    font-weight: 500;
    color: rgb(50,50,50);
    text-align: center;
  }
  .table-headers{
    div{
      display: inline-block;
      padding: 17px 5px;
      p{
        font-size: 14px;
        font-weight: 600;
        color: rgb(30,30,30);
      }
      &:last-child{
        p{
          text-align: right;
        }
      }
    }
  }
  .table-row{
    div{
      display: inline-block;
      padding: 15px 0 8px 0;
      border-top: 1px solid rgb(220,220,220);
      p{
        font-size: 14px;
        font-weight: 500;
        //color: rgb(30,30,30);
      }
      &:last-child{
        p{
          text-align: right;
        }
      }
    }
  }
}

.usage-container{
  width: 45%;
  .monthly-usage-container{
    padding-bottom: 20px;
    margin-bottom: 40px;
    border-bottom: 1px solid rgb(220,220,220);
    position: relative;
    .expand-answer-usage-details{
      position: absolute;
        top: 44px;
        left: -30px;
      height: 20px;
      width: 20px;
      background-size: 11px;
      background-image: url("../../assets/icons/toggle-arrow.svg");
      background-repeat: no-repeat;
      background-position: center center;
      transition: all 0.15s ease;
      opacity: 0.8;
      cursor: pointer;
      &:hover{
        opacity: 1;
      }
      &.expanded{
        transform: rotate(90deg);
      }
    }
    h4{
      font-size: 17px;
      text-align: left;
      font-weight: 400;
      margin-bottom: 18px;
    }
    div{
      width: 100%;
      p{
        font-size: 15px;
        display: inline-block;
        width: 30%;
        color: rgb(50,50,50);
        &:first-child{
          font-weight: 600;
          white-space: nowrap;
        }
        &:last-child{
          float: right;
          text-align: right;
        }
      }
    }
    .answer-usage-details{
      padding-left: 20px;
      p{
        &:first-child{
          width: 26%;
        }
      }
    }
  }

  .survey-usage-container{
    margin-top: 20px;
    div{
      padding-top: 3px;
      padding-bottom: 3px;
    }
    p{
      display: inline-block;
      font-size: 15px;
      &:first-child{
        font-weight: 600;
      }
      &:last-child{
        float: right;
      }
    }
  }
}


.billing-settings-container{
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 15px;
  padding-top: 40px;
  border-top: 1px solid rgb(230,230,230);
  .hide-wallet-toggler{
    p{
      font-size: 14px;
      font-weight: 600;
      margin: 0;
      margin-right: 20px;
    }
    .ant-switch-checked{
      background: linear-gradient(135deg, #36dca7 1%,#19c6af 100%);
      border: 0.5px solid #20A379;
    }
    & > *{
      display: inline-block;
    }
  }
}


.topup-container{
  width: 30%;
  .table-headers{
    div{
      width: 50%;
    }
  }
  .table-row{
    div{
      width: 50%;
      &:last-child{
        color: #17D189;
      }
    }
  }
}


.topup-request-modal{

  h3{
    font-size: 50px;
    margin: 0px;
  }
  h4{
    font-size: 18px;
  }
  input, button{
    display: block;
    width: 80%;
    margin: 0 auto;
    margin-top: 20px;
  }
  input{
    padding: 8px 12px;
    border: 1px solid rgb(230,230,230);
    border-radius: 6px;
    text-align: center;
    &:focus{
      border: 1px solid #17D189;
      outline: none;
    }
  }
  button{
    font-size: 14px;
    font-weight: 600;
    color: white;
    height: 39px;
    padding: 0px 13px 1px 13px;
    background: #2c3052; /* Old browsers */
    opacity: .95;
    background: -moz-linear-gradient(top, #2c3052 0%, #1e2032 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, #2c3052 0%,#1e2032 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, #2c3052 0%,#1e2032 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    border: 1px solid rgb(210,210,210);
    box-shadow: 0 0 3px 0 rgba(0,0,0,.05);
    border-color: black;
    opacity: .95;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    &:hover{
      opacity: 1;
    }

  }
}



@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {

.wallet-container{
  width: 90%;
}

.table-container{
  .table-headers{
    div{
      padding: 17px 5px;
      p{
        font-size: 13px;
      }
    }
  }
  .table-row{
    div{
      padding: 15px 0 8px 0;
      p{
        font-size: 13px;
      }
    }
  }
}

.usage-container{
  width: 90%;
  .table-headers,
  .table-row{
    div{
      width: 25% !important;
    }
  }
}

.topup-container{
  width: 70%;
}




}

// Ipad Portrait
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {

}


</style>
